exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/components/app/admin/user/admin-user/admin-user.component.css
// module id = ./src/components/app/admin/user/admin-user/admin-user.component.css
// module chunks = main